import api from './client';

export const authAPI = {
  signup: async (email, password, firstName, lastName) => {
    const response = await api.post('/auth/signup', {
      email,
      password,
      first_name: firstName,
      last_name: lastName,
    });
    return response.data;
  },

  login: async (email, password) => {
    const response = await api.post('/auth/login', { email, password });
    return response.data;
  },

  verifyCode: async (email, code) => {
    const response = await api.post('/auth/verify-code', { email, code });
    return response.data;
  },

  resendCode: async (email) => {
    const response = await api.post('/auth/resend-code', { email });
    return response.data;
  },

  getMe: async () => {
    const response = await api.get('/auth/me');
    return response.data;
  },
};

export default authAPI;
